import EditorField from "../../Utils/EditorField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
import RadioButtonField from "../../Utils/RadioButtonField"
import styles from "../../../../styles/Participant-Employment.module.css"
import TextField from "../../Utils/TextField"
import NumberField from "../../Utils/NumberField"
const PhysicalHealth = ({ formik }) => {
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.physical_1}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_1.value}
          label={careerProfileLabels.physicalHealth.physicalHealth_1.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.physical_2}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.physicalHealth.physicalHealth_2.label}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_2.value}
        />
      </div>
      <hr className={styles.line} style={{ marginTop: "20px" }}></hr>
      <label
        className={styles.label}
        style={{ fontSize: "16px", fontWeight: "600", lineHeight: "22px" }}
      >
        Do you have any problems with the following?
      </label>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.physicalHealth.physicalHealth_3.label}
          value={formik.values.physical_3}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_3.value}
          short
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.physicalHealth.physicalHealth_4.label}
          value={formik.values.physical_4}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_4.value}
          short
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.physicalHealth.physicalHealth_5.label}
          value={formik.values.physical_5}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_5.value}
          short
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <TextField
          value={formik.values.physical_6}
          setValue={formik.setFieldValue}
          label={careerProfileLabels.physicalHealth.physicalHealth_6.label}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_6.value}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.physicalHealth.physicalHealth_7.label}
          value={formik.values.physical_7}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_7.value}
          short
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <TextField
          value={formik.values.physical_8}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_8.value}
          label={careerProfileLabels.physicalHealth.physicalHealth_8.label}
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={careerProfileLabels.physicalHealth.physicalHealth_9.label}
          value={formik.values.physical_9}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_9.value}
          short
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <NumberField
          value={formik.values.physical_10}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_10.value}
          label={careerProfileLabels.physicalHealth.physicalHealth_10.label}
          maxValue={10000}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.physicalHealth.physicalHealth_11.label}
          value={formik.values.physical_11}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_11.value}
          short
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          gap: "20px",
          marginTop: "30px",
        }}
      >
        <NumberField
          value={formik.values.physical_12}
          setValue={formik.setFieldValue}
          label={careerProfileLabels.physicalHealth.physicalHealth_12.label}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_12.value}
          maxValue={24}
        />
        <NumberField
          value={formik.values.physical_13}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_13.value}
          label={careerProfileLabels.physicalHealth.physicalHealth_13.label}
          maxValue={168}
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <TextField
          value={formik.values.physical_14}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.physicalHealth.physicalHealth_14.value}
          label={careerProfileLabels.physicalHealth.physicalHealth_14.label}
        />
      </div>
    </>
  )
}
export default PhysicalHealth
